export default "__VITE_ASSET__BPUyDmkv__"